import * as React from 'react'
import { FormikProps } from 'formik'
import { IGlobalSettingsAssistance } from '../../types/global-settings'
import TextField from '../ui/TextField'
import TextArea from '../ui/TextArea'
import { IAssistanceCategoryObject } from '../../types/assistance'
import Dropdown, { IDropdownOption } from '../ui/Dropdown'

interface IAssistanceFormProps {
  formikProps: FormikProps<IGlobalSettingsAssistance>
  children: React.ReactNode
  categories: IAssistanceCategoryObject[]
}

const AssistanceForm = (props: IAssistanceFormProps) => {
  const options: IDropdownOption[] = []
  for (const i of Object.keys(props.categories)) {
    const cat: IAssistanceCategoryObject = props.categories[i]
    options.push({
      label: cat.name,
      value: cat.id
    })
  }
  return (
    <form onSubmit={props.formikProps.handleSubmit}>
      <div className='mb1'>
        <div className='h6'>Category</div>
        <Dropdown
          placeholder={'Category'}
          defaultOption={options.length > 0 ? options[0] : null}
          options={options}
          name={'category'}
        />
        <div className='error'>
          {props.formikProps.touched.category && props.formikProps.errors.category && (
            <span className='h6 font-red'>{props.formikProps.errors.category}</span>
          )}
        </div>
      </div>
      <div className='mb1'>
        <TextField
          title='Type'
          name={'type'}
          optional={false}
          error={props.formikProps.errors.type}
          classNameContainer={'mr1'}
          onChange={props.formikProps.handleChange}
          value={props.formikProps.values.type}
          className='mt1 p1 border-light-grey4 rounded h5'
          placeholder='Type'
        />
        <div className='error'>
          {props.formikProps.touched.type && props.formikProps.errors.type && (
            <span className='h6 font-red'>{props.formikProps.errors.type}</span>
          )}
        </div>
      </div>
      <div className='mb1'>
        <TextArea
          title='Instruction'
          name={'instruction'}
          optional={false}
          error={props.formikProps.errors.instruction}
          classNameContainer={'mr1'}
          isTouched={props.formikProps.touched.instruction}
          onChange={props.formikProps.handleChange}
          value={props.formikProps.values.instruction}
          className='mt1 p1 border-light-grey4 rounded h5'
          placeholder='Instruction'
        />
        <div className='error'>
          {props.formikProps.touched.instruction && props.formikProps.errors.instruction && (
            <span className='h6 font-red'>{props.formikProps.errors.instruction}</span>
          )}
        </div>
      </div>
      {props.children}
    </form>
  )
}

export default AssistanceForm



// WEBPACK FOOTER //
// ./src/components/global-settings/AssistanceForm.tsx